/**
 * Reads Meta's browser cookies (`_fbp` browser id, `_fbc` click id) so they can
 * be sent with the order and forwarded to the Conversions API server-side for
 * event matching. Returns only the cookies that are present; safe to call in
 * non-browser contexts (returns an empty object).
 */
export function readFbCookies(): { fbp?: string; fbc?: string } {
  if (typeof document === 'undefined') return {}

  const read = (name: string): string | undefined => {
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`))
    return match?.[1] === undefined ? undefined : decodeURIComponent(match[1])
  }

  const result: { fbp?: string; fbc?: string } = {}
  const fbp = read('_fbp')
  const fbc = read('_fbc')
  if (fbp) result.fbp = fbp
  if (fbc) result.fbc = fbc
  return result
}
